export const createBase64Image = (avatar: string, format: "jpeg" | "png" = "jpeg") =>
  `data:image/${format};base64,${avatar}`;

export const defaultUserAvatar = "/images/empty_avatar.jpg";
